export const generatedModelRunLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-versioned-model-run-ledger",
  "operatingRule": "Every investor, research, or reviewer conclusion must cite a model run hash, inputs, assumption hashes, evidence hashes, uncertainty settings, and promotion blockers.",
  "runCount": 3,
  "evidence": {
    "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "sourceRefreshReportHash": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
    "sidecarValidationReportHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
  },
  "runs": [
    {
      "id": "run-hybrid-base-2026-06-19",
      "label": "Hybrid base feasibility run",
      "purpose": "Canonical beta decision-support run used for the generated feasibility report.",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "claimState": "model-derived-unvalidated",
      "selectedScenario": {
        "scenarioId": "hybrid",
        "name": "Hybrid Moon -> Asteroid -> Mercury",
        "utility": 65.69,
        "benefitScore": 80.53,
        "riskScore": 47.09,
        "uncertaintyPenalty": 12,
        "rank": 2
      },
      "inputs": {
        "scenarioSet": "Primary set (6)",
        "horizonYears": 18,
        "capitalUsdBn": 280,
        "launchMassT": 160
      },
      "weights": {
        "benefits": {
          "energy": 1,
          "vacuum": 0.75,
          "optionality": 1,
          "processFit": 1,
          "resourceConfidence": 1
        },
        "risks": {
          "transport": 1,
          "thermal": 0.9,
          "comms": 0.8,
          "feedstock": 1,
          "processMaturity": 0.8
        }
      },
      "uncertainty": {
        "iterations": 256,
        "seed": "run-hybrid-base-2026-06-19",
        "selectedMedianUtility": 65.77,
        "selectedP10P90": [
          63.67,
          67.91
        ],
        "selectedWinProbabilityPercent": 26.95
      },
      "businessCase": {
        "businessReadiness": 72.6,
        "totalProgramNeedBn": 61.13,
        "capitalGapBn": 0,
        "fundingCoveragePercent": 100
      },
      "scenarioRanking": [
        {
          "rank": 1,
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.12,
          "uncertaintyPenalty": 8
        },
        {
          "rank": 2,
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "utility": 65.69,
          "uncertaintyPenalty": 12
        },
        {
          "rank": 3,
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "utility": 51.37,
          "uncertaintyPenalty": 18
        },
        {
          "rank": 4,
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "utility": 42.95,
          "uncertaintyPenalty": 24
        },
        {
          "rank": 5,
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "utility": 40.78,
          "uncertaintyPenalty": 12
        },
        {
          "rank": 6,
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "utility": 37.95,
          "uncertaintyPenalty": 26
        }
      ],
      "paretoFrontier": [
        "moon-first"
      ],
      "inputHashes": {
        "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
        "weights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
        "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
        "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
        "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "evidenceHashes": {
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
      },
      "replayContract": {
        "state": "reproducible-from-repo-generator",
        "generatorScript": "scripts/generate-model-run-ledger.mjs",
        "reproducibleCommand": "npm run science:runs",
        "verificationCommand": "node --test tests/model-run-ledger.test.mjs",
        "expectedSelectedScenarioId": "hybrid",
        "expectedRankOneScenarioId": "moon-first",
        "deterministicSeed": "run-hybrid-base-2026-06-19",
        "dependencyHashes": {
          "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
          "weights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
          "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
          "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
          "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
          "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        "outputPath": "public/model-run-ledger.json",
        "replayBoundary": "This replays deterministic planning logic only. It does not generate external SPICE/Orekit/GMAT/Tudat physics artifacts or promote commercial claims."
      },
      "promotionBlockers": [
        "Cost and schedule outputs are planning heuristics until dated cost-source records are attached.",
        "Trajectory/event-window claims require passing sidecar runtime artifacts.",
        "Asteroid resource claims require candidate-specific taxonomy, spectra, or mission evidence."
      ],
      "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207"
    },
    {
      "id": "run-conservative-moon-first-2026-06-19",
      "label": "Conservative Moon-first stress run",
      "purpose": "Stress test proving Mercury-first is not hardcoded and conservative assumptions can prefer nearer infrastructure.",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "claimState": "model-derived-unvalidated",
      "selectedScenario": {
        "scenarioId": "moon-first",
        "name": "Moon-first Bootstrap",
        "utility": 67.12,
        "benefitScore": 66.95,
        "riskScore": 33.91,
        "uncertaintyPenalty": 8,
        "rank": 1
      },
      "inputs": {
        "scenarioSet": "Primary set (6)",
        "horizonYears": 12,
        "capitalUsdBn": 80,
        "launchMassT": 90
      },
      "weights": {
        "benefits": {
          "energy": 1,
          "vacuum": 0.75,
          "optionality": 1,
          "processFit": 1,
          "resourceConfidence": 1
        },
        "risks": {
          "transport": 1,
          "thermal": 0.9,
          "comms": 0.8,
          "feedstock": 1,
          "processMaturity": 0.8
        },
        "transportBurden": null,
        "thermalLoad": null,
        "resourceConfidence": null,
        "processMaturity": null
      },
      "uncertainty": {
        "iterations": 256,
        "seed": "run-conservative-moon-first-2026-06-19",
        "selectedMedianUtility": 66.95,
        "selectedP10P90": [
          65.29,
          68.78
        ],
        "selectedWinProbabilityPercent": 71.48
      },
      "businessCase": {
        "businessReadiness": 76.3,
        "totalProgramNeedBn": 48.91,
        "capitalGapBn": 0,
        "fundingCoveragePercent": 100
      },
      "scenarioRanking": [
        {
          "rank": 1,
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.12,
          "uncertaintyPenalty": 8
        },
        {
          "rank": 2,
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "utility": 65.69,
          "uncertaintyPenalty": 12
        },
        {
          "rank": 3,
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "utility": 51.37,
          "uncertaintyPenalty": 18
        },
        {
          "rank": 4,
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "utility": 42.95,
          "uncertaintyPenalty": 24
        },
        {
          "rank": 5,
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "utility": 40.78,
          "uncertaintyPenalty": 12
        },
        {
          "rank": 6,
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "utility": 37.95,
          "uncertaintyPenalty": 26
        }
      ],
      "paretoFrontier": [
        "moon-first"
      ],
      "inputHashes": {
        "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
        "weights": "sha256-248f44bffa52cd71b631edd713a8877d08ce98083b44f4965678cd9290e7d51f",
        "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
        "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
        "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "evidenceHashes": {
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
      },
      "replayContract": {
        "state": "reproducible-from-repo-generator",
        "generatorScript": "scripts/generate-model-run-ledger.mjs",
        "reproducibleCommand": "npm run science:runs",
        "verificationCommand": "node --test tests/model-run-ledger.test.mjs",
        "expectedSelectedScenarioId": "moon-first",
        "expectedRankOneScenarioId": "moon-first",
        "deterministicSeed": "run-conservative-moon-first-2026-06-19",
        "dependencyHashes": {
          "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
          "weights": "sha256-248f44bffa52cd71b631edd713a8877d08ce98083b44f4965678cd9290e7d51f",
          "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
          "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
          "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
          "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        "outputPath": "public/model-run-ledger.json",
        "replayBoundary": "This replays deterministic planning logic only. It does not generate external SPICE/Orekit/GMAT/Tudat physics artifacts or promote commercial claims."
      },
      "promotionBlockers": [
        "Cost and schedule outputs are planning heuristics until dated cost-source records are attached.",
        "Trajectory/event-window claims require passing sidecar runtime artifacts.",
        "Asteroid resource claims require candidate-specific taxonomy, spectra, or mission evidence."
      ],
      "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601"
    },
    {
      "id": "run-asteroid-feedstock-probe-2026-06-19",
      "label": "Asteroid feedstock uncertainty probe",
      "purpose": "Probe whether asteroid scenarios can compete before candidate-specific taxonomy, spectra, or mission evidence exists.",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "claimState": "model-derived-unvalidated",
      "selectedScenario": {
        "scenarioId": "asteroid-first",
        "name": "Asteroid Feedstock-first",
        "utility": 51.37,
        "benefitScore": 69.21,
        "riskScore": 54.8,
        "uncertaintyPenalty": 18,
        "rank": 3
      },
      "inputs": {
        "scenarioSet": "Primary set (6)",
        "horizonYears": 20,
        "capitalUsdBn": 180,
        "launchMassT": 120
      },
      "weights": {
        "benefits": {
          "energy": 1,
          "vacuum": 0.75,
          "optionality": 1,
          "processFit": 1,
          "resourceConfidence": 1
        },
        "risks": {
          "transport": 1,
          "thermal": 0.9,
          "comms": 0.8,
          "feedstock": 1,
          "processMaturity": 0.8
        },
        "strategicOptionality": null,
        "resourceConfidence": null,
        "feedstockUncertainty": null,
        "transportBurden": null
      },
      "uncertainty": {
        "iterations": 256,
        "seed": "run-asteroid-feedstock-probe-2026-06-19",
        "selectedMedianUtility": 51.43,
        "selectedP10P90": [
          48.27,
          54.36
        ],
        "selectedWinProbabilityPercent": 0
      },
      "businessCase": {
        "businessReadiness": 60.2,
        "totalProgramNeedBn": 69.76,
        "capitalGapBn": 0,
        "fundingCoveragePercent": 100
      },
      "scenarioRanking": [
        {
          "rank": 1,
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.12,
          "uncertaintyPenalty": 8
        },
        {
          "rank": 2,
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "utility": 65.69,
          "uncertaintyPenalty": 12
        },
        {
          "rank": 3,
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "utility": 51.37,
          "uncertaintyPenalty": 18
        },
        {
          "rank": 4,
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "utility": 42.95,
          "uncertaintyPenalty": 24
        },
        {
          "rank": 5,
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "utility": 40.78,
          "uncertaintyPenalty": 12
        },
        {
          "rank": 6,
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "utility": 37.95,
          "uncertaintyPenalty": 26
        }
      ],
      "paretoFrontier": [
        "moon-first"
      ],
      "inputHashes": {
        "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
        "weights": "sha256-3a819aa26d821b001a6fa4b0c2ae9cd86f281248a724dd0068a497910827626b",
        "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
        "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
        "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
      },
      "evidenceHashes": {
        "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
        "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
        "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
      },
      "replayContract": {
        "state": "reproducible-from-repo-generator",
        "generatorScript": "scripts/generate-model-run-ledger.mjs",
        "reproducibleCommand": "npm run science:runs",
        "verificationCommand": "node --test tests/model-run-ledger.test.mjs",
        "expectedSelectedScenarioId": "asteroid-first",
        "expectedRankOneScenarioId": "moon-first",
        "deterministicSeed": "run-asteroid-feedstock-probe-2026-06-19",
        "dependencyHashes": {
          "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
          "weights": "sha256-3a819aa26d821b001a6fa4b0c2ae9cd86f281248a724dd0068a497910827626b",
          "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
          "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
          "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
          "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        "outputPath": "public/model-run-ledger.json",
        "replayBoundary": "This replays deterministic planning logic only. It does not generate external SPICE/Orekit/GMAT/Tudat physics artifacts or promote commercial claims."
      },
      "promotionBlockers": [
        "Cost and schedule outputs are planning heuristics until dated cost-source records are attached.",
        "Trajectory/event-window claims require passing sidecar runtime artifacts.",
        "Asteroid resource claims require candidate-specific taxonomy, spectra, or mission evidence."
      ],
      "runHash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22"
    }
  ],
  "ledgerHash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2"
}
;
